(function(){
  var ids=['start','fehler','sicherheit','herkunft'];
  var obs=new IntersectionObserver(function(en){
    en.forEach(function(e){
      if(e.isIntersecting){
        document.querySelectorAll('.secnav a').forEach(function(a){ a.classList.remove('on'); });
        var a=document.querySelector('.secnav a[href="#'+e.target.id+'"]');
        if(a) a.classList.add('on');
      }
    });
  },{rootMargin:'-80px 0px -65% 0px',threshold:0});
  ids.forEach(function(id){ var el=document.getElementById(id); if(el) obs.observe(el); });
})();

document.querySelectorAll('.fx').forEach(function(fx){
  var head=fx.querySelector('.fx-head'),body=fx.querySelector('.fx-body'),inner=fx.querySelector('.fx-in');
  head.addEventListener('click',function(){
    var open=fx.classList.toggle('open');
    body.style.height=open?inner.offsetHeight+'px':'0px';
  });
  window.addEventListener('resize',function(){
    if(fx.classList.contains('open')) body.style.height=inner.offsetHeight+'px';
  });
});
